import styled from 'styled-components';

export const StyledPill = styled.div`
  border: 1px solid #2e7d32;
  background-color: #e8f5e9;
  border-radius: 2px;
  color: #2e7d32;
  margin: 0;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 10px;
  font-weight: bold;
  padding: 2px 4px;
`;
